import plusFill from '@iconify/icons-eva/close-circle-outline';
import { Icon } from '@iconify/react';
// material
import { Button, Container, Stack, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';

//
// components
import Page from '../components/Page';
import Scrollbar from '../components/Scrollbar';
import { FlightListAssignForm } from '../components/flightList';
import { useTranslation } from '../common/LocalizationProvider';
// ----------------------------------------------------------------------

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '50vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

export default function FlightListAssign() {
  const t = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Page title={t('FL_Assign_Title')}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={0}>
          <Typography variant="h4" gutterBottom>
            {t('FL_Assign')}
          </Typography>
          <Button
            variant="contained"
            onClick={() => navigate('/flight/list', { replace: true })}
            startIcon={<Icon icon={plusFill} />}
            color="secondary"
          >
            {t('btn_Cancel')}
          </Button>
        </Stack>
        <Scrollbar>
          <ContentStyle>
            <FlightListAssignForm
              deviceId={location.state !== null ? location.state.deviceId : 0}
              groupId={location.state !== null ? location.state.groupId : 0}
              startTime={location.state !== null ? location.state.startTime : 0}
              endTime={location.state !== null ? location.state.endTime : 0}
            />
          </ContentStyle>
        </Scrollbar>
      </Container>
    </Page>
  );
}
